import styled from 'styled-components';

export const AcessosDialogContainer = styled.div`
  width: 520px;
  max-width: 90vw;
  max-height: 80vh;
  border: 1px solid var(--primary);
  background: var(--background);
  color: var(--primary);
  border-radius: 10px;
  padding: 1rem;
  gap: 1rem;
  display: flex;
  flex-direction: column;

  header {
    width: 100%;
    display: flex;
    align-items: center;
    padding-bottom: 0.75rem;
    border-bottom: 1px solid #c8ded8;

    h1 {
      flex: 1;
      font-size: 1.35rem;
      font-weight: 700;
      color: var(--primary);
      text-align: center;
    }

    svg {
      cursor: pointer;
    }
  }
`;

export const Subtitle = styled.p`
  color: #56615f;
  font-size: 0.875rem;
  text-align: center;
  margin: 0;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  overflow-y: auto;
  max-height: 55vh;
  padding-right: 0.25rem;
`;

export const EmptyText = styled.p`
  color: #56615f;
  font-size: 0.95rem;
  text-align: center;
  padding: 1.5rem 0;
  margin: 0;
`;

export const AcessoItem = styled.div`
  background: #eef7f4;
  border: 1px solid #c8ded8;
  border-radius: 10px;
  padding: 0.85rem 1rem;
`;

export const AcessoNome = styled.p`
  margin: 0;
  color: #263a36;
  font-size: 0.95rem;
  font-weight: 700;
`;

export const AcessoMeta = styled.p`
  margin: 0.35rem 0 0;
  color: #56615f;
  font-size: 0.8rem;
`;

export const TipoBadge = styled.span`
  display: inline-block;
  margin-top: 0.55rem;
  background: var(--primary);
  color: #fff;
  border-radius: 8px;
  padding: 0.15rem 0.55rem;
  font-size: 0.7rem;
  font-weight: 700;
`;
